"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
exports.default = (function (_a) {
    var theme = _a.theme, className = _a.className, blue = _a.blue, gray = _a.gray, white = _a.white, _b = _a.size, size = _b === void 0 ? 1 : _b, others = tslib_1.__rest(_a, ["theme", "className", "blue", "gray", "white", "size"]);
    var _c;
    return (React.createElement("div", { style: { fontSize: utils_1.toREMString(size) }, className: classnames_1.default(theme.loader, className, (_c = {},
            _c[theme.blue] = blue,
            _c[theme.gray] = gray,
            _c[theme.white] = white,
            _c)) },
        React.createElement("i", { className: theme.circle }),
        React.createElement("i", { className: theme.circle }),
        React.createElement("i", { className: theme.circle })));
});
